import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3873d046"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-scrollbar-y container" }

import useGiftPackaging, { GiftPackagingViewMode } from '@/shared/checkout/gift-packaging/useGiftPackaging';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import GiftPackagingDetails from '@/shared/checkout/gift-packaging/ui/GiftPackagingDetails.vue';
import GiftPackagingConfirm from '@/shared/checkout/gift-packaging/ui/GiftPackagingConfirm.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPackagingDialog',
  setup(__props) {

const { hasActiveItemId, clearActiveItemId, viewMode } = useGiftPackaging();

const isDetailsViewMode = computed<boolean>(() => viewMode.value === GiftPackagingViewMode.Details);

const close = () => {
    clearActiveItemId();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(hasActiveItemId),
    class: "fixed inset-0 p-30 mx-auto z-1 bg-white text-center sm:p-50 sm:pb-30 sm:relative sm:inset-auto sm:w-screen-90 sm:h-auto md:w-screen-80 md:p-80 md:py-50 xl:max-w-1200",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (close()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(isDetailsViewMode))
              ? (_openBlock(), _createBlock(GiftPackagingDetails, { key: 0 }))
              : (_openBlock(), _createBlock(GiftPackagingConfirm, { key: 1 }))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})